"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var balloonEgg = {
    name: "balloon",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["b", "a", "l", "l", "o", "o", "n"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/RUo4HfH.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "300px";
        img.style.height = "600px";
        img.style.transition = "13s all";
        img.style.position = "fixed";
        img.style.right = "-500px";
        img.style.bottom = "0px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.right = "calc(100% + 500px)";
        }, 50);
        // window.setTimeout(function(){
        //   img.style.right = 'calc(100% + 375px)';
        // }, 4500);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 10300);
    },
};
exports.default = balloonEgg;
